import { createSelector } from '@reduxjs/toolkit';

import { State } from 'types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.ResetPassword;

export const statusSelector = createSelector(rootSelector, (resetPassword) => resetPassword.status);
export const errorSelector = createSelector(rootSelector, (resetPassword) => resetPassword.error);
export const errorMessageSelector = createSelector(rootSelector, (resetPassword) => resetPassword.message);

export default {
  statusSelector,
  errorSelector,
  errorMessageSelector,
};
